export class OAuthCallbackHandler {
  public static handleCallback(): void {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (window.opener) {
      window.opener.postMessage({
        type: 'JOB_WIDGET_OAUTH_CALLBACK',
        code: code,
        state: state,
        error: error
      }, window.location.origin);

      window.close();
    } else {
      if (code && state) {
        const storedState = sessionStorage.getItem('job_widget_state');
        if (state === storedState) {
          sessionStorage.setItem('job_widget_oauth_code', code);
        }
      }

      const returnUrl = sessionStorage.getItem('job_widget_return_url') || '/';
      window.location.href = returnUrl;
    }
  }

  public static renderCallbackPage(): void {
    document.body.innerHTML = `
      <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      ">
        <div style="
          background: white;
          padding: 40px;
          border-radius: 12px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          text-align: center;
          max-width: 400px;
        ">
          <div style="
            width: 60px;
            height: 60px;
            margin: 0 auto 20px;
            background: #10b981;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          ">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="white">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
            </svg>
          </div>
          <h2 style="margin: 0 0 10px; color: #111827;">Authentication Successful</h2>
          <p style="color: #6b7280; margin: 0;">This window will close automatically...</p>
        </div>
      </div>
    `;

    setTimeout(() => {
      OAuthCallbackHandler.handleCallback();
    }, 100);
  }
}